import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import Cards from "../../components/AdminSideComponents/Cards";
import bedsLogo from "../../Assets/Logos/BedsLogo.png";
import InmatesLogo1 from "../../Assets/Logos/InmatesLogo.png";
import InmatesLogo from "../../Assets/Logos/InmatesLogo.png";
import issuesLogo from "../../Assets/Logos/IssuesLogo.png";
import MoneyLogo from "../../Assets/Logos/MoneyLogo.png";
import WalletLogo from "../../Assets/Logos/Walletlogo.png";
import bedsOccupied from "../../Assets/Logos/bedsOccupied.png";
import axios from "axios";

const Dashboard = () => {
  const [totalOccupiedBeds, setTotalOccupiedBeds] = useState(0);
  const [totalVacantBeds, setTotalVacantBeds] = useState(0);
  const [totalCheckIns, setTotalCheckIns] = useState(0);
  const [totalIssues, setTotalIssues] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [totalBookings, setTotalBookings] = useState(0);
  const [analyticsExpense, setAnalyticsExpense] = useState([]);
  const [rentCollectedInThisMonth, setRentCollectedInThisMonth] = useState(0);
  const [totalDues, setTotalDues] = useState(0);
  // Fetch total count of beds data
  const getBedCounts = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/beds/get_bed_counts`,
    };

    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        console.log("Response of getBedCounts: ", response.data);
        setTotalOccupiedBeds(response.data.totalOccupiedBeds);
        setTotalVacantBeds(response.data.totalVacantBeds);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  //Fetch total checkIn counts
  const getBookingCounts = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/booking/get_bookings_count`,
    };

    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        console.log("Response of getBookingCounts: ", response.data);
        setTotalBookings(response.data.totalBookings);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCheckInCounts = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/check_in/get_checkIn_counts`,
    };

    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        console.log("Response of getBookingCounts: ", response.data);
        setTotalCheckIns(response.data.totalCheckIns);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  //Fetch total number of issues raised
  const getIssueCounts = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/issues/getanalysisissues`,
    };

    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        console.log("Response of getIssueCounts: ", response.data);
        setTotalIssues(response.data.data.total);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  //Fetch expense analytics
  const getAnalyticsExpenses = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/expense/getanalyticsexpense`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------> Analytics Expenses ", response.data);
        setAnalyticsExpense(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Fetch rent collected in this month
  const getRentAnalytics = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-rent-analytics`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------> Rent collected in this month: ", response.data);
        setRentCollectedInThisMonth(
          response.data.rentCollectedInThisMonth[0].total
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Fetch total dues to be collected
  const getTotalDues = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-total-dues`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getTotalDues: ", response.data);
        setTotalDues(response.data.totalDues[0].total);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  console.log("analyticsExpense: ", analyticsExpense);
  console.log("rentCollectedInThisMonth: ", rentCollectedInThisMonth);
  console.log("totalDues: ", totalDues);

  useEffect(() => {
    getBedCounts();
    getCheckInCounts();
    getIssueCounts();
    getBookingCounts();
    getAnalyticsExpenses();
    getRentAnalytics();
    getTotalDues();
  }, []);

  const financialYearMonths = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  console.log(
    "analyticsExpense?.monthWiseExpense",
    analyticsExpense?.monthWiseExpense
  );
  const expensesData = new Array(12).fill(0);
  // Map fetched expenses into the correct position in the financial year
  analyticsExpense?.monthWiseExpense?.forEach(({ _id, total }) => {
    console.log("I am here");
    const monthIndex = (_id.month - 1 + 9) % 12; // Convert to financial year index
    expensesData[monthIndex] = total;
  });

  console.log("expenseData: ", expensesData);
  const chartOptions = {
    chart: {
      type: "area",
      height: "100%",
      width: "100%",
      toolbar: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 640,
        options: {
          chart: {
            height: 300,
          },
        },
      },
      {
        breakpoint: 1024,
        options: {
          chart: {
            height: 400,
          },
        },
      },
    ],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: financialYearMonths,
      title: {
        text: "Months",
      },
    },
    yaxis: {
      title: {
        text: "Expenses",
      },
    },
  };

  const chartSeries = [
    {
      name: "Monthly Expenses",
      data: expensesData,
    },
  ];

  const items = [
    {
      name: "Numbers Of Beds Available",
      numberOfItems: totalVacantBeds || 0,
      icon: bedsLogo,
    },
    {
      name: "Numbers Of Beds Occupied",
      numberOfItems: totalOccupiedBeds || 0,
      icon: bedsOccupied,
    },
    {
      name: "Numbers Of Bookings",
      numberOfItems: totalBookings || 0,
      icon: InmatesLogo,
    },
    {
      name: "Numbers Of Issues Raised",
      numberOfItems: totalIssues || 0,
      icon: issuesLogo,
    },
    {
      name: "Total Expenses",
      numberOfItems: analyticsExpense?.totalExpense || 0,
      icon: WalletLogo,
    },
    {
      name: "Current Month Expense",
      numberOfItems: analyticsExpense?.currentMonthExpense || 0,
      icon: WalletLogo,
    },
    {
      name: "Rent Collected In This Month",
      numberOfItems: rentCollectedInThisMonth || 0,
      icon: MoneyLogo,
    },
    {
      name: "Total Dues",
      numberOfItems: totalDues || 0,
      icon: WalletLogo,
    },
  ];
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const financialYear = `${currentMonth >= 3 ? currentYear : currentYear - 1}-${
    currentMonth >= 3
      ? (currentYear + 1).toString().slice(-2)
      : currentYear.toString().slice(-2)
  }`;

  return (
    <div className="dashboardContainer p-6 bg-primarybgColor">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Dashboard
      </h1>
      <Cards items={items} />
      <div className="chart sm:h-[30rem] h-[26rem] bg-white mt-10 rounded-lg p-3 sm:p-6 ">
        <div className="flex justify-between items-center">
          <h1 className="text-[18px] text-primaryTextColor sm:text-[24px] font-bold">
            Monthly Expenses Details ({financialYear})
          </h1>
          {/* <select name="" id="" className="p-2 border-2 rounded-md">
            <option value="">Current Month</option>
            <option value="">January</option>
            <option value="">February</option>
            <option value="">March</option>
            <option value="">April</option>
            <option value="">May</option>
            <option value="">June</option>
            <option value="">July</option>
            <option value="">August</option>
            <option value="">September</option>
            <option value="">October</option>
            <option value="">November</option>
            <option value="">December</option>
          </select> */}
        </div>

        <Chart
          options={chartOptions}
          series={chartSeries}
          type="area"
          height="100%"
        />
      </div>
    </div>
  );
};

export default Dashboard;
